import React, { Component } from "react";
import ApiRequest from "../../libs/request";
import Nav from "./Nav";
import FeedNav from "./FeedNav";
import PersonalInfo from "./PersonalInfo";
import WorkHistory from "./WorkHistory";
import AdditionalInfo from "./AdditionalInfo";
import ProfileStats from "./ProfileStats";
import CustomModal from "../shared/CustomModal";
import { FaCamera, FaExpand, FaEye } from "react-icons/fa";
import ActorProfile from "./ActorProfile";


import { _backgroundImagePrompt } from "../../libs/constants";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
class UserProfile extends Component {
  state = {
    tab: "profile",
    cover: "",
    profile_photo: "",
      isProfileModalOpen: false,
  };

  tabs = [
    { key: "profile", label: "Personal Info" },
    { key: "work", label: "Work History" },
    { key: "info", label: "Additional Info" },
    { key: "actor", label: "Actor Profile" },
  ];
  renderContent = () => {
    switch (this.state.tab) {
      case "profile":
        return <PersonalInfo user={this.state} />;
      case "work":
        return <WorkHistory istab={true} user={this.state} />;
      case "info":
        return <AdditionalInfo user={this.state} />;
      case "actor":
        return   <div className="actor-profile-view" style={{ padding: "", width: "100%" }}>
            <h2>Actor Profile</h2>
            
            {/* Legal Age Required Badge */}
            <div style={{ marginBottom: "20px" }}>
              <label style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px", display: "block", color: "#000" }}>
                <input
                  type="radio"
                  name="legal_age"
                  checked={this.state.legal_age}
                  readOnly
                  style={{ marginRight: "10px" }}
                />
                18 OR OLDER OR LEGALLY EMANCIPATED
              </label>
            </div>

            {/* Birthdate */}
            <div style={{ marginBottom: "20px", borderTop: "1px solid #e0e0e0", paddingTop: "15px" }}>
              <div style={{ fontSize: "16px", color: "#333", fontWeight: "500" }}>Birthdate</div>
              <DatePicker
                selected={this.state.birthdate ? new Date(this.state.birthdate) : null}
                onChange={(date) => {
                  const formattedDate = date ? date.toISOString().split('T')[0] : "";
                  this.setState({ birthdate: formattedDate });
                }}
                dateFormat="MM/dd/yyyy"
                placeholderText="Select a date"
                className="form-control"
                style={{
                  width: "100%",
                  padding: "12px",
                  marginTop: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  fontSize: "14px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
              />
            </div>

            {/* Age Range (to play) */}
            <div style={{ marginBottom: "20px", borderTop: "1px solid #e0e0e0", paddingTop: "15px" }}>
              <div style={{ fontSize: "16px", color: "#333", fontWeight: "500", marginBottom: "10px" }}>
                Age Range (to play)
              </div>
              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ flex: 1 }}>
                  <label style={{ display: "block", marginBottom: "8px", fontSize: "12px", color: "#999" }}>
                    FROM
                  </label>
                  <Select
                    options={Array.from({ length: 60 }, (_, i) => i + 18).map((age) => ({
                      value: age,
                      label: `${age} years`,
                    }))}
                    value={this.state.age_from ? { value: this.state.age_from, label: `${this.state.age_from} years` } : null}
                    onChange={(option) => this.setState({ age_from: option ? option.value : null })}
                    isClearable
                    isSearchable
                    placeholder="Select Age"
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ display: "block", marginBottom: "8px", fontSize: "12px", color: "#999" }}>
                    TO
                  </label>
                  <Select
                    options={Array.from({ length: 60 }, (_, i) => i + 18).map((age) => ({
                      value: age,
                      label: `${age} years`,
                    }))}
                    value={this.state.age_to ? { value: this.state.age_to, label: `${this.state.age_to} years` } : null}
                    onChange={(option) => this.setState({ age_to: option ? option.value : null })}
                    isClearable
                    isSearchable
                    placeholder="Select Age"
                  />
                </div>
              </div>
            </div>

            {/* Expandable Sections - 2 columns layout */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", marginTop: "20px" }}>
              {[
                { label: "Union Status", field: "union_status", options: ["SAG-AFTRA", "Non-Union", "Both", "Eligible"] },
                { label: "Authentic Roles*", field: "authentic_roles", options: ["Hero", "Villain", "Comic Relief", "Love Interest", "Supporting Role"] },
                { label: "Ethnic Appearance", field: "ethnic_appearance", options: ["Caucasian", "African American", "Asian", "Hispanic", "Middle Eastern", "Mixed"] },
                { label: "Athletic Endeavors", field: "athletic_endeavors", options: ["Boxing", "Running", "Swimming", "Martial Arts", "Gymnastics", "Parkour"] },
                { label: "Performance Skills", field: "performance_skills", options: ["Singing", "Dancing", "Instruments", "Comedy", "Stunts", "Accents"] },
                { label: "Accents", field: "accents", options: ["British", "Irish", "French", "Spanish", "German", "Russian", "Australian"] },
                { label: "ESL", field: "esl", options: ["Yes", "No"] },
                { label: "Fluent Languages", field: "fluent_languages", options: ["Spanish", "French", "German", "Italian", "Mandarin", "Japanese"] },
                { label: "Disabilities", field: "disabilities", options: ["Deaf", "Blind", "Mobility Impaired", "Speech Impaired", "Cognitive"] },
                { label: "Assistive Devices", field: "assistive_devices", options: ["Wheelchair", "Crutches", "Hearing Aid", "Prosthetic", "Service Dog"] },
              ].map((item) => (
                <div
                  key={item.field}
                  style={{
                    flex: "1 1 calc(50% - 10px)",
                    minWidth: "250px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ fontSize: "16px", color: "#333", fontWeight: "500", marginBottom: "8px" }}>
                    {item.label}
                  </div>
                  <Select
                    options={item.options.map((option) => ({
                      value: option,
                      label: option,
                    }))}
                    value={this.state[item.field] ? { value: this.state[item.field], label: this.state[item.field] } : null}
                    onChange={(option) => this.setState({ [item.field]: option ? option.value : null })}
                    isClearable
                    isSearchable
                    placeholder={`Select ${item.label}`}
                  />
                </div>
              ))}
            </div>
          </div>;
      default:
        return null;
    }
  };

  render() {
    const user = this.state;
console.log("UserProfile props", this.state);

    return (
      <>
        <Nav user={this.props.user} />

        <div className="container-fluid">
          <div className="row feed">

            {/* LEFT SIDEBAR */}
            <div className=" feed-container">
              <div className=" feed-left">
                <FeedNav user={this.props.user} />
              </div>
            </div>

            {/* MAIN CONTENT */}
            <div className="col-12 col-lg-10">

              {/* COVER */}
              <div className="position-relative">
                <div
                  className="w-100"
                  style={{
                    height: "220px",
                    background: `url(${user.cover}) center/cover`,
                    borderRadius: "0 0 20px 20px",
                    position: "relative",
                  }}
                >
                  {/* Cover Image Preview Modal */}
                  {user.cover && (
                    <CustomModal
                      width="50%"
                      trigger={
                        <FaExpand
                          style={{
                            fontSize: "30px",
                            color: "white",
                            cursor: "pointer",
                            position: "absolute",
                            right: "15px",
                            bottom: "15px",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            padding: "8px",
                            borderRadius: "4px",
                          }}
                        />
                      }
                      content={<img src={user.cover} style={{ width: "100%" }} />}
                    />
                  )}
                </div>

                {/* PROFILE IMAGE */}
                <div
                  className="position-absolute"
                  style={{
                    bottom: "-50px",
                    left: "20px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      width: "110px",
                      height: "110px",
                      borderRadius: "50%",
                      background: `url(${user.profile_photo}) center/cover`,
                      border: "4px solid white",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      position: "relative",
                    }}
                  >
                    {/* Profile Photo Preview Modal */}
                    {user.profile_photo && (
                      <CustomModal
                        width="500px"
                        trigger={
                          <FaEye
                            style={{
                              fontSize: "22px",
                              color: "white",
                              cursor: "pointer",
                              position: "absolute",
                              bottom: "8px",
                              right: "8px",
                              backgroundColor: "rgba(0, 0, 0, 0.6)",
                              padding: "6px",
                              borderRadius: "4px",
                            }}
                          />
                        }
                        content={<img src={user.profile_photo} style={{ width: "100%" }} />}
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* USER INFO */}
              <div className="bg-white p-4 mt-5 rounded shadow-sm">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">

                  <div>
                    <h4 className="mb-1">
                      {user.first_name} {user.last_name}
                    </h4>
                    <p className="text-muted mb-0">
                      {user.user_occupations?.[0]?.title || "No occupation"}
                    </p>
                  </div>

                  <div className="mt-3 mt-md-0">
                    <ProfileStats user={user} />
                  </div>

                </div>
              </div>

              {/* TABS */}
              <div className="bg-white mt-3 p-2 rounded shadow-sm">
                <div className="d-flex flex-wrap gap-2">

                  {this.tabs.map((tab) => {
  const isActive = this.state.tab === tab.key;
  return (
    <button
      key={tab.key}
      onClick={() => this.setState({ tab: tab.key })}
      style={{
        
        backgroundColor: isActive ? "#ff9500" : "white",
        color: isActive ? "white" : "#ff9500",
        border: "0px solid #ff9500",
        borderRadius: "8px",
        padding: "5px 20px",
        cursor: "pointer",
        fontWeight: 500,
        transition: "all 0.3s ease",
        marginRight: "10px",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.backgroundColor = isActive ? "#ff8c00" : "#ff9500";
        e.currentTarget.style.color = "white";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.backgroundColor = isActive ? "#ff9500" : "white";
        e.currentTarget.style.color = isActive ? "white" : "#ff9500";
      }}
    >
      {tab.label}
    </button>
  );
})}
                </div>
              </div>

              {/* CONTENT */}
              <div className="bg-white mt-3 p-3 rounded shadow-sm">
                {this.renderContent()}
              </div>

            </div>
          </div>
        </div>
      </>
    );
  }

  componentDidMount() {
    const id = this.props.match.params.id;

    let api = new ApiRequest("get", "/user/user-info?user_id=" + id);
    api.send({}, (response) => {
      const user = response.data.user_info;
      this.setState({
        ...user,
        cover: user.cover,
        profile_photo: user.profile_photo,
      });
    });
  }
}

export default UserProfile;